import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
/* eslint-disable */

export default /*#__PURE__*/_defineComponent({
  __name: 'CoverElButton',
  props: {
    size: {},
    type: {},
    plain: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


const typeStyle = computed(() => {
    return plainStyle(props.type)
})
const plainStyle = (type?: string): string => { // 根据类型名返回不同的类名来绑定不同的style
    if (!type) { type = 'default' }
    if (props.plain) {
        return type + '-plain';
    } else {
        return type;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    class: _normalizeClass(typeStyle.value),
    type: _ctx.type ?? '',
    size: _ctx.size ?? '',
    plain: _ctx.plain
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "type", "size", "plain"]))
}
}

})